export default function NotFound() {
	return (
		<main>
			<div className="hero">
				<h2 className="hero-title">404 {":("}</h2>
			</div>
		</main>
	);
}
